import React, { SVGProps } from "react";

export default function SupSave(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 10C4.89543 10 4 10.8954 4 12V14C4 15.1046 4.89543 16 6 16H14C15.1046 16 16 15.1046 16 14V12C16 10.8954 15.1046 10 14 10H6ZM14 11H6C5.44772 11 5 11.4477 5 12V14C5 14.5523 5.44772 15 6 15H14C14.5523 15 15 14.5523 15 14V12C15 11.4477 14.5523 11 14 11Z"
        fill="currentColor"
      />
      <path d="M11 4H12.5V5.5H11V4Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1716 2C13.702 2 14.2107 2.21071 14.5858 2.58579L17.4142 5.41421C17.7893 5.78929 18 6.29799 18 6.82843V16C18 17.1046 17.1046 18 16 18H4C2.89543 18 2 17.1046 2 16V4C2 2.89543 2.89543 2 4 2H13.1716ZM16 17H4C3.44772 17 3 16.5523 3 16V4C3 3.44772 3.44772 3 4 3H4.5V5C4.5 6.38071 5.61929 7.5 7 7.5H12C13.3807 7.5 14.5 6.38071 14.5 5V3.91421L16.7071 6.12132C16.8946 6.30886 17 6.56321 17 6.82843V16C17 16.5523 16.5523 17 16 17ZM13.5 3.05547V5C13.5 5.82843 12.8284 6.5 12 6.5H7C6.17157 6.5 5.5 5.82843 5.5 5V3H13.1716C13.2845 3 13.3954 3.01909 13.5 3.05547Z"
        fill="currentColor"
      />
    </svg>
  );
}
